import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import * as SVG from 'app/shared-components/Icons';
import FuseDialog from '@fuse/core/FuseDialog';
import { closeDialog } from 'app/store/fuse/dialogSlice';
import DIALOGS from 'app/constants/dialogs';

const COMPACT_SIZE = { maxWidth: '360px', height: '520px' };
const DEFAULT_SIZE = { maxWidth: '96rem', height: '96vh' };

const PaymentDialog = ({ paymentUrl, onPaymentComplete, onPaymentFailed, onClose: onCloseProp }) => {
  const dispatch = useDispatch();
  const [compact, setCompact] = useState(false);
  const [retryKey, setRetryKey] = useState(0);

  const onClose = useCallback(() => {
    dispatch(closeDialog());
    setCompact(false);
    setRetryKey(0);
    onCloseProp?.();
  }, [dispatch, onCloseProp]);

  useEffect(() => {
    const handleMessage = (event) => {
      const { type } = event.data ?? {};

      if (type === 'payment_resize') {
        setCompact(true);
      }

      if (type === 'payment_success') {
        onPaymentComplete?.();
      }

      if (type === 'payment_failed' || type === 'payment_cancelled') {
        onClose();
        onPaymentFailed?.(event.data);
      }

      if (type === 'payment_close') {
        onClose();
      }

      if (type === 'payment_retry') {
        setCompact(false);
        setRetryKey((k) => k + 1);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onClose, onPaymentComplete, onPaymentFailed]);

  const paperSize = compact ? COMPACT_SIZE : DEFAULT_SIZE;

  return (
    <FuseDialog
      fullWidth
      maxWidth={compact ? 'xs' : 'lg'}
      dialogId={DIALOGS.PAYMENT}
      onClose={onClose}
      PaperProps={{ sx: { ...paperSize, transition: 'all 0.3s ease' } }}
    >
      <Box width="100%" height="100%">
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}>
          <SVG.HeroIconsOutline iconId="x" size={24} />
        </IconButton>
        {paymentUrl && (
          <iframe
            key={retryKey}
            src={paymentUrl}
            title="Payment"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        )}
      </Box>
    </FuseDialog>
  );
};

export default PaymentDialog;
